document.addEventListener("DOMContentLoaded", function() {

  // Trade mark on products title
  document.querySelectorAll('.ProductMeta__Title, .ProductItem__Title').forEach(function(productTitle) {
    productTitle.innerHTML = productTitle.innerHTML.replace('™', '<span class="symbol-mark">™</span>');
    productTitle.innerHTML = productTitle.innerHTML.replace('®', '<span class="symbol-mark">®</span>');
  });

  // Toggle
  document.querySelectorAll('.slb-toggle-action').forEach(function(toggleAction) {
    toggleAction.addEventListener('click', function(e) {
      e.preventDefault();
      var toggleTitle = this;
      var toggleParent = toggleTitle.closest('.slb-toggle');
      var toggleContent = toggleParent.querySelector('.slb-toggle-content');
      toggleParent.classList.toggle('slb-active');
      if (toggleContent.style.display === "none" || toggleContent.style.display === "") {
        toggleContent.style.display = "block";
        var start = null;
        var animateScroll = function(timestamp) {
          if (!start) start = timestamp;
          var progress = timestamp - start;
          var position = toggleParent.getBoundingClientRect().top - 120;
          window.scrollTo(0, position * (progress / 400));
          if (progress < 400) {
            //window.requestAnimationFrame(animateScroll);
          }
        };
        //window.requestAnimationFrame(animateScroll);
      } else {
        toggleContent.style.display = "none";
      }
    });
  });


  // Review stars product
  if (document.querySelector('.template-product .ProductMeta')) {
    var addStars = setInterval(function() {
      var stampedBadge = document.querySelector('.template-product .ProductMeta .stamped-badge');
      if (stampedBadge) {
        var parentStars = stampedBadge;
        var theRating = parentStars.getAttribute('data-rating');
        parentStars.insertAdjacentHTML('afterbegin', '<span class="t-24"><strong>' + theRating + '</strong></span><div class="slb-stars"><div class="slb-total-stars" style="width: ' + ((theRating / 5) * 100) + '%;"></div></div>');
        if (document.querySelector('.template-product .ProductMeta .stamped-badge .slb-stars')) {
          clearInterval(addStars);
        }
      }
    }, 500);
  }

});
